import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import * as React from "react";
import { Breadcrumbs } from "../shared/breadcrumbs";
export const BlogPageHero = ({
    bgImage,
    header,
    className = "",
    links
}: {
    bgImage: ImageDataLike;
    header: string;
    className?: string;
    links?: { path: string; text: string }[];
}) => {
    return (
        <div className={`${className} relative w-full`}>
            <GatsbyImage
                alt=""
                image={getImage(bgImage)}
                className="h-[280px] md:h-[330px] xl:h-[350px]"
            />

            {/* Mask */}
            <div className="absolute top-0 h-full w-full bg-black/30"></div>
            {links && <Breadcrumbs links={links} stopTreeAfter={1} />}
            <h1 className="pointer-events-none absolute top-[20px] bottom-[20px] grid w-full items-center px-[24px] text-center text-[26px] font-bold leading-[1.3em] tracking-wide text-white xm:px-12 xm:text-[30px] sm:text-4xl md:px-40">
                {header}
            </h1>
        </div>
    );
};
